// This brand's email templates, keyed the way the chase engine schedules them
// (track prefix + days before renewal). SMS copy lives in ../timeline.ts, the
// same way server/src/utils/timeline keeps it next to the day it goes out on.

import type { EmailTemplate } from "../types";
import { brand } from "./brand";

import * as a21 from "./auto-renew/a21";
import * as ad21 from "./auto-renew/ad21";
import * as ac21 from "./pay-in-full/ac21";
import * as ac14 from "./pay-in-full/ac14";
import * as ac10 from "./pay-in-full/ac10";
import * as ac7 from "./pay-in-full/ac7";
import * as ac3 from "./pay-in-full/ac3";
import * as ac2 from "./pay-in-full/ac2";
import * as ac1 from "./pay-in-full/ac1";
import * as na21 from "./monthly-dd/na21";
import * as na14 from "./monthly-dd/na14";
import * as na10 from "./monthly-dd/na10";
import * as na7 from "./monthly-dd/na7";
import * as na3 from "./monthly-dd/na3";
import * as na2 from "./monthly-dd/na2";
import * as na1 from "./monthly-dd/na1";
import * as wb3 from "./win-back-lapse/wb3";
import * as wb7 from "./win-back-lapse/wb7";
import * as wb14 from "./win-back-lapse/wb14";
import * as wb28 from "./win-back-lapse/wb28";
import * as an30 from "./win-back-anniversary/an30";
import * as an14 from "./win-back-anniversary/an14";
import * as an7 from "./win-back-anniversary/an7";
import * as ren0 from "./renewed/ren0";

export type Touchpoint = EmailTemplate;

const t = (m: EmailTemplate): Touchpoint => ({ subject: m.subject, html: m.html });

export const TEMPLATES: Record<string, Touchpoint> = {
  A21: t(a21),
  AD21: t(ad21),

  AC21: t(ac21),
  AC14: t(ac14),
  AC10: t(ac10),
  AC7: t(ac7),
  AC3: t(ac3),
  AC2: t(ac2),
  AC1: t(ac1),

  NA21: t(na21),
  NA14: t(na14),
  NA10: t(na10),
  NA7: t(na7),
  NA3: t(na3),
  NA2: t(na2),
  NA1: t(na1),

  WB3: t(wb3),
  WB7: t(wb7),
  WB14: t(wb14),
  WB28: t(wb28),

  AN30: t(an30),
  AN14: t(an14),
  AN7: t(an7),

  REN0: t(ren0),
};

export { brand };
